import { Llm } from 'data/firestore/agent/llm/types';
import { Respondermapping } from 'data/firestore/agent/respondermapping/types';
import { createContext } from 'react';
import { Workflow } from './types';

export interface Context {
    responders?: Llm[];
    responderMapping?: Respondermapping[];
    automations?: Workflow[];
}

const context = createContext<Context>({
    responders: [],
    responderMapping: [],
    automations: [],
});

export const { Provider, Consumer } = context;

export default context;
